import { Moment } from 'moment';
import { AbsenceReason } from '../../../../core-module/services/absence/types';

export const isBeforeAllowedAbsenceDate = (date: Moment, soonestAllowedAbsenceDate: Moment) => {
  return date.isBefore(soonestAllowedAbsenceDate, 'day');
};

export const getAbsenceReasonDisplayName = (reason: AbsenceReason) => {
  switch (reason) {
    case 'Holiday':
      return 'Vakantie';
    case 'Illness':
      return 'Ziekte';
    case 'Other':
      return 'Anders';
    case 'Unknown':
      return 'Onbekend';
    default:
      return '?';
  }
};
